export default {
  type: ''
};



// WEBPACK FOOTER //
// ./src/store/modules/notification/state.js